<template>
  <div>
    <vue-headful title="Maak je profiel compleet" />
    <Header page_title="Maak je profiel compleet" goBackClass="invisible" :do-not-show-all="!this.prevRoute || this.prevRoute.name !== 'applicant-edit'" />
    <div v-if="initialized" class="pt-3 px-4 mx-2 pb-4 questionnaire">
      <div class="container-fluid px-0 pb-1 mb-2">
        <form @submit.prevent="onSubmit" novalidate>
          <button type="submit" ref="submit" hidden>submit</button>
          <div class="step-question">
            <!--<span>STAPPENPLAN {{ answered }}%</span>-->
            <register-steps :steps="{1:'Gegevens',2:'Opleidingen',3:'Ervaringen',4:'Aan de slag!'}" :totalAnswered="answered" currentStep="2" v-if="!prevRoute || (prevRoute.name !== 'applicant-edit' && prevRoute.name !== 'applicant-dashboard')"></register-steps>
            <div v-if="Object.keys(questions).length" v-for="(arr, key1) in guide" v-bind:key="key1">
              <div
                :id="questions[q.url].id"
                v-for="q in arr"
                v-bind:key="q.url"
                v-show="current_step == q.url"
                v-bind:class="[current_step == q.url ? 'active-question' : '']"
              >
                <div class="sd-title medium step-container">
                  <span class="steps">{{ step }}/{{ steps }}</span>
                  {{ questions[q.url].display }}
                </div>
                <div class="form">
                  <div v-if="q.url == 6" >
                    <div class="form-group">
                      <textarea class="form-control" maxlength="400" placeholder="Welke daginvulling kan jij bieden als invaller voor de klas, welke onderwijservaring heb jij en welke (aanvullende) relevante diploma’s heb jij? Max 400 karakters" v-model="form.user_answers[questions[q.url].id]['answer']"  rows="5"></textarea>
                    </div>
                  </div>
                  <div v-if="elContains([1, 2, 3, 4, 5], q.url, 1)">
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="form.user_answers[questions[q.url].id]['answer']"
                          value="YES"
                          v-bind:id="`yes-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`yes-` + questions[q.url].id"
                        >Ja</label>
                      </div>
                    </div>
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="NO"
                          v-bind:id="`no-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`no-` + questions[q.url].id"
                        >Nee</label>
                      </div>
                    </div>
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="STUDYING"
                          v-bind:id="`s-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`s-` + questions[q.url].id"
                        >Studerend</label>
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      elContains(q.url, '_YES', 2) &&
                        !elContains(q.url, '_YES_EXTRA', 3)
                    "
                  >
                    <div class="form-group w-square-icon sd-input">
                      <label>Wanneer heb je het diploma behaald</label>
                      <select
                        class="custom-select"
                        v-model="
                          form.user_answers[questions[q.url].id]['answer']
                        "
                        v-bind:id="`year-` + questions[q.url].id"
                        required
                      >
                        <option value="">Selecteer een antwoord</option>
                        <option
                          v-for="year in years"
                          :value="year"
                          v-bind:key="
                            `year-` + questions[q.url].id + `year` + year
                          "
                        >{{ year }}</option>
                      </select>
                      <div
                        class="icon-wrapper dropdown position-absolute align-self-center"
                      >
                        <svg-icon icon="chevron_s" />
                      </div>
                    </div>
                  </div>
                  <div v-else-if="elContains(q.url, '_YES_EXTRA', 4)">
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="YES"
                          v-bind:id="`yes-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`yes-` + questions[q.url].id"
                        >Ja</label>
                      </div>
                    </div>
                    <div class="d-block">
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[q.url].id]['answer']
                          "
                          value="NO"
                          v-bind:id="`no-` + questions[q.url].id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`no-` + questions[q.url].id"
                        >Nee</label>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="elContains(q.url, 'STUDYING_A', 5)">
                    <ul class="list-unstyled">
                      <li
                        v-for="item in answers[1]"
                        v-bind:key="questions[q.url].id + '-' + item.id"
                      >
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="
                              form.user_answers[questions[q.url].id]['answer']
                            "
                            :value="item.answer"
                            v-bind:id="
                              `fulltime-` + questions[q.url].id + '-' + item.id
                            "
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="
                              `fulltime-` + questions[q.url].id + `-` + item.id
                            "
                          >{{ item.answer }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div v-else-if="elContains(q.url, 'STUDYING_B', 6)">
                    <ul class="list-unstyled" v-if="q.seen_academic_year">
                      <li
                        v-for="item in answers[2]"
                        v-bind:key="questions[q.url].id + '-' + item.id"
                      >
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="
                              form.user_answers[questions[q.url].id]['answer']
                            "
                            :value="item.answer"
                            v-bind:id="
                              `acadyear-` + questions[q.url].id + '-' + item.id
                            "
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="
                              `acadyear-` + questions[q.url].id + `-` + item.id
                            "
                          >{{ item.answer }}</label>
                        </div>
                      </li>
                    </ul>
                    <ul class="list-unstyled" v-if="q.seen_academic_year == false">
                      <li
                        v-for="item in answers[3]"
                        v-bind:key="questions[q.url].id + '-' + item.id"
                      >
                        <div class="custom-control custom-radio">
                          <input
                            type="radio"
                            class="custom-control-input"
                            v-model="
                              form.user_answers[questions[q.url].id]['answer']
                            "
                            :value="item.answer"
                            v-bind:id="
                              `acadyear-` + questions[q.url].id + '-' + item.id
                            "
                          />
                          <label
                            class="custom-control-label"
                            v-bind:for="
                              `acadyear-` + questions[q.url].id + `-` + item.id
                            "
                          >{{ item.answer }}</label>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div hidden>
          <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
        </div>
      </div>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          v-if="next_step != 'SUBMIT' && prevRoute && prevRoute.name === 'applicant-edit'"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >Volgende</button>
        <button
          v-else-if="next_step != 'SUBMIT'"
          type="button"
          title="Volgende stap"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >Volgende stap</button>
        <button
          v-if="next_step == 'SUBMIT'"
          type="button"
          title="Opslaan"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >Volgende stap</button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg-icon icon="success" />
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center mb-4">Top!</div>
            <div class="">
              Je opleidingen staan in je profiel. Nu ben je beter vindbaar voor onze opdrachtgevers.
            </div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
              v-if="Object.keys(experience).length < 5"
              :to="{
                name: 'applicant-step_2',
                params: { action: 'save' }
              }"
              title="Ga door naar je werkervaring"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
            >Ga door naar je werkervaring</router-link>
<!--            <router-link-->
<!--              v-else-if="prevRoute"-->
<!--              :to="{-->
<!--                name: 'applicant-profile'-->
<!--              }"-->
<!--              title="Bekijk profiel"-->
<!--              class="btn btn-light btn-block"-->
<!--              v-ripple="'rgba(192, 189, 187, 0.35)'"-->
<!--            >Bekijk profiel</router-link>-->
            <router-link
              v-else
              :to="{
                name: 'applicant-dashboard'
              }"
              title="Naar mijn Dashboard"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
            >Naar mijn Dashboard</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
var old = null;
export default {
  components: {
    VStepper
  },
  data: function() {
    return {
      guide: {
        1: [
          { url: 1 },
          { url: "1_YES", option: "years" },
          { url: "1_STUDYING_A", option: "fulltime" },
          {
            url: "1_STUDYING_B",
            option: "academic_year",
            seen_academic_year: true
          }
        ],
        2: [
          { url: 2 },
          { url: "2_YES", option: "years" },
          { url: "2_YES_EXTRA", option: "yes/no" },
          { url: "2_STUDYING_A", option: "fulltime" },
          {
            url: "2_STUDYING_B",
            option: "academic_year",
            seen_academic_year: true
          }
        ],
        3: [
          { url: 3 },
          { url: "3_YES", option: "years" },
          { url: "3_STUDYING_A", option: "fulltime" },
          {
            url: "3_STUDYING_B",
            option: "academic_year",
            seen_academic_year: true
          }
        ],
        4: [
          { url: 4 },
          { url: "4_YES", option: "years" }
          // { url: "4_STUDYING_A", option: "fulltime" },
          // { url: "4_STUDYING_B", option: "academic_year" }
        ],
        5: [{ url: 5 }, { url: "5_YES", option: "years" }]
      },
      steps: 5,
      step: 1,
      answered: 0,
      done: null,
      user: "",
      experience: null,
      questions: {},
      questions_array: {},
      answers: {},
      answers_array: {},
      form: {
        user_answers: {}
      },
      current_year: new Date().getFullYear(),
      current_step: "1",
      next_step: null,
      submit: null,
      prevRoute: null,
      change_subs: false,
      initialized: false,
    };
  },
  props: ["action", "question_branch"],
  async created() {
    // this.$options.old;
    this.$store.state.loading = true;
  },
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    step: {
      immediate: true,
      handler() {
        this.answered = Math.floor((this.step / this.steps) * 100);
      }
    },
    form: {
      immediate: true,
      handler: function() {
        localStorage.setItem("form-pending", JSON.stringify(true));
        this.computeNextStep();
      },
      deep: true
    },
    current_step: {
      immediate: true,
      handler: function() {
        if (this.elContains(["1", "2", "3", "4", "5"], this.current_step, 7)) {
          this.step = parseInt(this.current_step);
        }
      },
      deep: true
    }
  },
  updated: function() {
    this.$nextTick(function() {
      this.computeNextStep();
    });
  },
  computed: {
    years() {
      var ctr = this.current_year;
      const last = this.current_year - 49;
      var arr = [];
      while (ctr >= last) {
        arr.push(ctr);
        ctr--;
      }
      return arr;
    }
  },
  methods: {
    async fetchData() {
        if (localStorage.getItem("branch") === '3') {
            await this.$router.push({name: 'applicant-dashboard'})
        }
      await this.getQuestions();
      await this.getAnswers();
      await this.fillForm();
      await this.getUserAnswers();
      this.user = JSON.parse(localStorage.getItem("user"));
      if (this.user.experience) {
        this.experience = JSON.parse(this.user.experience);
      }
      localStorage.removeItem("form-pending");
      this.initialized = true;
      this.$store.state.loading = false;
    },
    elContains(str, target, debug) {
        if (typeof str !== "string") {
            str = JSON.stringify(str);
        }

      return str.includes(target);
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/education/1/";

      // assign questions
      for (var obj in this.guide) {
        promises.push(
          new Promise(resolve => {
            for (var arr in this.guide[obj]) {
              this.$http({
                method: "GET",
                url: q_url + this.guide[obj][arr].url
              }).then(
                result => {
                  var q_id = result.data.data[0].id;
                  var q_number = result.data.data[0].number;
                  this.$set(this.questions, q_number, {
                    id: result.data.data[0].id,
                    display: result.data.data[0].display
                  });
                  this.$set(this.questions_array, q_number, q_id);
                  resolve();
                },
                error => {
                  console.error(error);
                }
              );
            }
          })
        );
      }
      return Promise.all(promises);
    },
    //assign answers
    async getAnswers() {
      let promises = [];
      var a_url = this.$apiURI + "/answers/1/";
      var arr = {
        fulltime: 1,
        academic_year: 2,
        academic_year_accelerated: 3
      };
      var answerIds = {};

      Object.keys(arr).forEach(itemKey => {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: a_url + itemKey + "/1"
            }).then(
              result => {
                this.$set(
                  this.answers,
                  arr[itemKey], // qnumber
                  result.data.data
                );

                Object.keys(this.questions_array).forEach(questionNumber => {
                  promises.push(
                    new Promise(resolve => {
                      var question_id = this.questions_array[questionNumber];
                      var v;
                      if (
                        this.elContains(questionNumber, "_STUDYING_A", 8) &&
                        itemKey == "fulltime"
                      ) {
                        answerIds = {};
                        for (v in result.data.data) {
                          answerIds[result.data.data[v].id] = false;
                        }
                        if (answerIds) {
                          this.$set(this.answers_array, question_id, answerIds);
                        }
                      }
                      if (
                        this.elContains(questionNumber, "_STUDYING_B", 9) &&
                        itemKey == "academic_year"
                      ) {
                        answerIds = {};
                        for (v in result.data.data) {
                          answerIds[result.data.data[v].id] = false;
                        }
                        this.$set(this.answers_array, question_id, answerIds);
                      }
                      resolve();
                    })
                  );
                });
                resolve();
              },
              error => {
                console.error(error);
              }
            );
          })
        );
      });

      return Promise.all(promises);
    },
    async fillForm() {
      let promises = [];
      Object.keys(this.questions_array).forEach(questionNumber => {
        promises.push(
          new Promise(resolve => {
            var question_id = this.questions_array[questionNumber];
            this.$set(this.form.user_answers, question_id, {
              answer: ""
            });
            // if (
            //   this.elContains(["1", "2", "3", "4", "5"], questionNumber) ||
            //   this.elContains(questionNumber, "_YES")
            // ) {
            //   this.$set(this.form.user_answers, question_id, {
            //     answer: ""
            //   });
            // } else {
            //   if (this.elContains(questionNumber, "_STUDYING_A")) {
            //     this.$set(this.form.user_answers, question_id, {
            //       // answer_id: this.answers_array[question_id]
            //       answer: ""
            //     });
            //   }
            //   if (this.elContains(questionNumber, "_STUDYING_B")) {
            //     this.$set(this.form.user_answers, question_id, {
            //       // answer_id: this.answers_array[question_id]
            //       answer: ""
            //     });
            //   }
            // }
            resolve();
          })
        );
      });

      return Promise.all(promises);
    },
    getParentQuestions() {
      var arr = [];
      Object.keys(this.questions_array).forEach(questionNumber => {
        var question_id = this.questions_array[questionNumber];
        // if (this.elContains(["1", "2", "3", "4", "5"], questionNumber)) {
        arr.push(question_id);
        // }
      });
      // console.log(arr);
      return arr;
    },
    async getUserAnswers() {
      return new Promise((resolve, reject) => {
        var parentQs = this.getParentQuestions();
        var url = "applicant/answers/raw/1/education";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data.data) {
              this.raw = resp.data.data;
              for (var obj in this.raw) {
                if (
                  this.raw[obj].answer &&
                  this.elContains(parentQs, this.raw[obj].question_id, 10)
                ) {
                  this.form.user_answers[this.raw[obj].question_id][
                    "answer"
                  ] = this.raw[obj].answer;
                }
              }
              old = JSON.parse(JSON.stringify(this.form));
            }
            return resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            return reject(null);
          });
      });
    },
    // async updateUser() {
    //   return new Promise(resolve => {
    //     var user_token = JSON.parse(localStorage.getItem("user-token"));
    //     var url = this.$apiURI + "/legitimize";
    //     let formData = new FormData();
    //     for (var obj in this.form) {
    //       formData.append(obj, this.form[obj]);
    //     }
    //     this.$http
    //       .post(url, formData, {
    //         headers: {
    //           Authorization: "Bearer " + user_token,
    //           Accept: "application/json"
    //         }
    //       })
    //       .then(() => {
    //         localStorage.removeItem("form-pending");
    //         const notification = {
    //           type: "success",
    //           message: "Je hebt je gegevens succesvol aangepast. "
    //         };
    //         this.$store.dispatch("notification/replace", notification, {
    //           root: true
    //         });
    //         resolve();
    //       })
    //       .catch(error => {
    //         console.log(error);
    //         const notification = {
    //           type: "danger",
    //           message: "Er is een fout opgetreden."
    //         };
    //         this.$store.dispatch("notification/replace", notification, {
    //           root: true
    //         });
    //         this.$store.state.loading = false;
    //       });
    //   });
    // },
    computeNextStep() {
      var $id = $(".active-question");
      var answer = null;
      var old_answer = null;
      if ($id.length) {
        $id = $id.attr("id");
        answer = this.form.user_answers[$id]["answer"];
        old_answer = old.user_answers[$id]["answer"];
      }

      // step 1
      if (this.elContains(this.current_step, "2", 11)) {
        if (this.current_step == "2") {
          if (answer == "YES") {
            this.next_step = "2_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "2_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "3";
          }
        }
        if (this.current_step == "2_YES") {
          this.next_step = "2_YES_EXTRA";
        }
        if (this.current_step == "2_YES_EXTRA") {
          this.next_step = "3";
        }
        if (this.current_step == "2_STUDYING_A") {
          this.next_step = "2_STUDYING_B";
          //change options in academic years
          if (answer == "Versneld") {
            this.guide[1][4].seen_academic_year = false;
          } else {
            this.guide[1][4].seen_academic_year = true;
          }
        }
        if (this.current_step == "2_STUDYING_B") {
          this.next_step = "3";
        }
      }

      // step 2 (swap to 1)
      if (this.elContains(this.current_step, "1", 12)) {
        if (this.current_step == "1") {
          if (answer == "YES") {
            this.next_step = "1_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "1_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "2";
          }
        }
        if (this.current_step == "1_YES") {
          this.next_step = "2";
        }
        if (this.current_step == "1_STUDYING_A") {
          this.next_step = "1_STUDYING_B";
          if (answer == "Versneld") {
            this.guide[2][3].seen_academic_year = false;
          } else {
            this.guide[2][3].seen_academic_year = true;
          }
        }
        if (this.current_step == "1_STUDYING_B") {
          this.next_step = "2";
        }
      }

      // step 3
      if (this.elContains(this.current_step, "3", 13)) {
        if (this.current_step == "3") {
          if (answer == "YES") {
            this.next_step = "3_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "3_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "4";
          }
        }
        if (this.current_step == "3_YES") {
          this.next_step = "4";
        }
        if (this.current_step == "3_STUDYING_A") {
          this.next_step = "3_STUDYING_B";
          if (answer == "Versneld") {
            this.guide[3][3].seen_academic_year = false;
          } else {
            this.guide[3][3].seen_academic_year = true;
          }
        }
        if (this.current_step == "3_STUDYING_B") {
          this.next_step = "4";
        }
      }

      // step 4
      if (this.elContains(this.current_step, "4", 14)) {
        if (this.current_step == "4") {
          if (answer == "YES") {
            this.next_step = "4_YES";
          }
          if (answer == "STUDYING") {
            this.next_step = "5";
            // this.next_step = "4_STUDYING_A";
          }
          if (answer == "NO") {
            this.next_step = "5";
          }
        }
        if (this.current_step == "4_YES") {
          this.next_step = "5";
        }
        // if (this.current_step == "4_STUDYING_A") {
        //   this.next_step = "4_STUDYING_B";
        // }
        // if (this.current_step == "4_STUDYING_B") {
        //   this.next_step = "5";
        // }
      }

      // step 5
      if (this.elContains(this.current_step, "5", 15)) {
        if (this.current_step == "5") {
          if (answer == "YES") {
            this.next_step = "5_YES";
          }
          if (answer == "NO") {
            this.next_step = "SUBMIT";
          }
          if (answer == "STUDYING") {
            this.next_step = "SUBMIT";
          }
        }
        if (this.current_step == "5_YES") {
          this.next_step = "SUBMIT";
        }
      }

      // if current and old answer are not the same...
      // reset the sub
      if (answer != old_answer) {
        // console.log(
        //   "CHANGE SUB! " + "current: " + answer + " " + " old: " + old_answer
        // );
        this.change_subs = true;
      } else {
        this.change_subs = false;
      }

      window.scrollTo(0,0);
    },
    nextStep() {
      var next = this.validateForm();
      if (next) {
        if (this.next_step) {
          if (this.change_subs) {
            this.changeSub(this.current_step);
          }

          if (this.next_step == "SUBMIT") {
            this.submit = true;
          } else if (this.next_step) {
            this.current_step = this.next_step;
            this.next_step = null;
          }
        }
      }
    },
    validateForm() {
      var $checkradios = $('input[type="radio"]:visible');
      var $input = $('input[required="required"]:visible');
      var $textarea = $('textarea[required="required"]:visible');
      var $checkboxes = $('input[type="checkbox"]:visible');
      var $select = $("select:visible");

      if ($checkradios.length) {
        var checkedRadios = $('input[type="radio"]:visible:checked').length;
        if (!checkedRadios) {
          alert("Graag een antwoord selecteren."); // Please choose an answer.
          return false;
        }
      }

      if ($input.length) {
        var emptyInputs = $('input[required="required"]:invalid').length;
        if (emptyInputs) {
          alert("Graag het formulier volledig invullen."); // Please fill up form.
          return false;
        }
      }

      if ($textarea.length) {
        var emptyTexareas = $('textarea[required="required"]:invalid').length;
        if (emptyTexareas) {
          alert("Graag het formulier volledig invullen."); // Please fill up form.
          return false;
        }
      }

      if ($select.length) {
        var $id = $("select:visible")
          .closest(".active-question")
          .attr("id");
        var answer = this.form.user_answers[$id]["answer"];
        if (!answer) {
          alert("Graag een antwoord selecteren."); // Please choose an answer.
          return false;
        }
      }

      if ($checkboxes.length) {
        var checkedCheckboxes = $('input[type="checkbox"]:visible:checked')
          .length;
        if (!checkedCheckboxes) {
          alert("Graag een antwoord selecteren."); // Please choose an answer.
          return false;
        }
      }
      return true;
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async onSubmit() {
      var next = this.validateForm();
      if (next) {
        if (this.change_subs) {
          // console.log("inside submit");
          // console.log(this.current_step);
          this.changeSub(this.current_step);
        }
        // continue
        await this.save();
        await this.updateLocalUser();
        if (this.action == "next" && Object.keys(this.education).length >= 5) {
          // go to user profile
          // setTimeout(
          //   () =>
          //     this.$router.replace({
          //       name: "applicant-profile"
          //     }),
          //   5000
          // );
        }
      }
    },
    async save() {
      return new Promise(resolve => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/user_answer/education";
        if(this.question_branch) {
          url = url + '/' + this.question_branch;
        }

        let formData = {
          user_answer: this.form["user_answers"]
        };
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            this.done = true;
            localStorage.removeItem("form-pending");

            if (typeof dataLayer !== "undefined") {
              const dataLayerEvent = {
                event: "TeacherEducationEdit",
                eventCategory: "Teacher",
                eventAction: "Teacher – Education edit",
                eventLabel: "",
                eventValue: "1"
              };
              dataLayer.push(dataLayerEvent);
            }

            resolve();
          })
          .catch(() => {
            // console.log(error.response.data);
          });
      });
    },
    changeSub(target) {
      // console.log("change sub of: " + target);
      var sub = this.guide[target];
      for (var ctr in sub) {
        if (ctr > 0) {
          var id = this.questions_array[sub[ctr].url];
          this.form.user_answers[id]["answer"] = ""; // actual reset
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.savePending(to, from, next);
  }
};
</script>

<style scoped>
.step-question .icon,
.step-question .icon .svg {
  height: 114px;
}
.step-question .icon {
  width: 104px;
}
.form {
  margin: 30px 0 0;
}
</style>
